import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { JobStatusItemModule } from '../../../modules-shared/job-status-item/job-status-item.module';
import { ListPickerControlComponent } from './list-picker-control.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        JobStatusItemModule
    ],
    declarations: [
        ListPickerControlComponent
    ],
    exports: [
        ListPickerControlComponent
    ]
})
export class ListPickerControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-picker-control.module.ts